import { render, staticRenderFns } from "./view_TermsCondition.vue?vue&type=template&id=847a4c4a&scoped=true&"
import script from "./view_TermsCondition.vue?vue&type=script&lang=js&"
export * from "./view_TermsCondition.vue?vue&type=script&lang=js&"
import style0 from "./view_TermsCondition.vue?vue&type=style&index=0&id=847a4c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847a4c4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
